/**
 * Utility functions for working with PRD (Product Requirements Document) content
 */

/**
 * Extract title from PRD content
 * @param {string} prdContent - The PRD content to extract title from
 * @returns {string|null} - The extracted title or null if not found
 */
export const extractTitleFromPRD = (prdContent) => {
  if (!prdContent) return null;

  // Look for "Title: [title]" pattern
  const titleMatch = prdContent.match(/^Title:\s*(.+)$/m);
  if (titleMatch && titleMatch[1].trim()) {
    const title = titleMatch[1].trim();
    // Filter out version numbers and empty titles (handles "1.0", "Version 1.0", "Version: 1.0", etc.)
    const isVersionPattern =
      title.match(/^(version[\s:]*)?[\d.]+$/i) ||
      title.toLowerCase() === "version";
    if (title && !isVersionPattern) {
      return title;
    }
  }

  // Look for "Project Name: [title]" pattern
  const projectMatch = prdContent.match(/Project Name:\s*([^\n]+)/);
  if (projectMatch && projectMatch[1].trim()) {
    const title = projectMatch[1].trim();
    // Filter out version numbers
    const isVersionPattern =
      title.match(/^(version[\s:]*)?[\d.]+$/i) ||
      title.toLowerCase() === "version";
    if (title && !isVersionPattern) {
      return title;
    }
  }

  return null;
};
